import Icon from './src/icon.mjs';
export { iconProps } from './src/icon2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElIcon = withInstall(Icon);

export { ElIcon, ElIcon as default };
//# sourceMappingURL=index.mjs.map
